






























































// vue
import { Component, Vue } from 'vue-property-decorator'

// componnents
import { PageHeader } from '@/components'
import { TableListAfp } from '@/components/config'
import { Select } from '@/components/general'

// services
import { AfpService } from '@/services/config'

// utils
import { loading, alerts } from '@/utils'

// constants
import { currentYear, currentMonth, monthOptions, rangeYearsDefault } from '@/constants/dateTime'

// models
import { AfpForm, AfpModel, FiltersAfp } from '@/models/config'
import { BvModalEvent } from 'bootstrap-vue'

// views
import ModalCreateEditAfp from './modalCreateEdit.vue'

const newItem: AfpForm = {
  name: '',
  observations: '',
  is_active: true,
  items: []
}

@Component({
  name: 'AfpsIndex',
  components: {
    PageHeader,
    TableListAfp,
    ModalCreateEditAfp,
    Select
  }
})
export default class AfpsIndex extends Vue {
  showModal = false
  afp: AfpForm = newItem
  title = 'AFP'
  actionForm = 'save'
  idItemEdit: number|null = null
  monthOptions = monthOptions
  rangeYearsDefault = rangeYearsDefault
  items = [
    {
      text: 'Dashboard'
    },
    {
      text: 'AFP',
      active: true
    }
  ]

  filters: FiltersAfp = {
    year: currentYear,
    month: currentMonth
  }

  hideModal (event: BvModalEvent) {
    if (event.trigger !== 'ok') {
      this.showModal = false
    }
  }

  addNew () {
    this.idItemEdit = null
    this.actionForm = 'save'
    this.afp = newItem
    this.showModal = true
  }

  editItem (item: AfpModel) {
    this.afp = {
      name: item.name,
      observations: item.observations,
      is_active: item.is_active,
      items: item.items
    }
    if (item.id) {
      this.idItemEdit = Number(item.id)
    }
    this.actionForm = 'update'
    this.showModal = true
  }

  async deleteItem (item: AfpModel) {
    const msg = `Seguro que desea eliminar AFP: ${item.name}, y todos sus items (Año-Mes)`
    const confirm = await alerts.confirm(msg)
    if (confirm && item.id) {
      loading('show')
      await AfpService.delete(item.id)
      alerts.success()
      this.tableList.getAfpsWithPagination()
      loading('hide')
    }
  }

  async changeStatus (info: {id: number; status: boolean}) {
    loading('show')
    try {
      await AfpService.changeStatus(info.id, info.status)
      alerts.success()
      this.tableList.getAfpsWithPagination()
    } catch (e) {
      alerts.error()
    }
    loading('hide')
  }

  filterByDate () {
    this.tableList.getAfpsWithPagination()
  }

  get tableList (): Vue & { getAfpsWithPagination: () => void } {
    return this.$refs.table_list as Vue & { getAfpsWithPagination: () => void }
  }

  get itemInit (): AfpForm {
      return newItem
  }
}
